let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gbNlu")).then(() => parcelRequire('8so3a'));